import { render, staticRenderFns } from "./ContratoForm.vue?vue&type=template&id=2f2b980a&scoped=true&"
import script from "./ContratoForm.vue?vue&type=script&lang=js&"
export * from "./ContratoForm.vue?vue&type=script&lang=js&"
import style0 from "./ContratoForm.vue?vue&type=style&index=0&id=2f2b980a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2b980a",
  null
  
)

export default component.exports